<template>
  <div class="input-lifetime-bonus-days">
    <label class="input-lifetime-bonus-days__label">
      <span v-if="title" class="input-lifetime-bonus-days__title">{{ title }}</span>
      <input
        class="input-lifetime-bonus-days__input"
        type="text"
        placeholder="Бессрочно"
        v-model="days"
        v-mask="mask"
        v-on:blur="onBlur"
        v-bind:disabled="disabled"
        v-bind:title="'Срок действия бонусов (дней)'"
      />
    </label>
    <p
      class="input-lifetime-bonus-days__violations"
      role="alert"
      v-for="error in violations"
      v-bind:key="error"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>

export default {
  /**
   * @description  Компонент ввода времени действия бонусов.
   */
  name: 'InputLifetimeBonusDays',
  data() {
    return {
      days: this.value,
      /**
     * @description Наличие фокуса.
     * @type {boolean}
     */
      isFocused: false,
    };
  },
  methods: {
    onBlur() {
      if (Number(this.days) <= 0) {
        this.days = '';
      }
      this.$emit('input', this.days);
    },
  },
  props: {
    /**
     * @description Выключен
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: () => '',
    },
    value: {
      type: String,
      required: true,
    },
    violations: {
      type: Array,
      required: false,
      default: () => [],
    },
    mask: {
      type: String,
      required: false,
      default: () => '###',
    },
  },
};

</script>

<style scoped lang="scss">
.input-lifetime-bonus-days {
  &__title {
    font-weight: 400;
    line-height: 16px;
  }
  &__label {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }
  &__input {
    width: 100%;
    max-width: 152px;
    height: 40px;
    padding: 10px;
    font-size: 16px;
    border-radius: var(--input-border-radius);
    border: 1px solid var(--border-color);
    &::placeholder {
      color: var(--placeholder-color);
    }
    &:focus-visible {
      outline-color: var(--action-color);
    }
  }
  &__violations {
    padding: 0.125rem;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: var(--warning-color);
  }
}

@media screen and (max-width: 480px) {
  .input-lifetime-bonus-days {
    &__label {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
